/**
 * New js file to maintain all FFQ translations.
 */

export const Dictionary = {
    previous: {
    	'us': 'Back',
        'es': 'Atrás',
        'pt': 'Anterior',
        'de': 'Zurück',
        'fr': 'Précédent'
    },
    next: {
    	'us': 'Next',
        'es': 'Siguiente',
        'pt': 'Seguinte',
        'de': 'Weiter',
        'fr': 'Suivant'
        
    }
};